import { render, staticRenderFns } from "./u-tabs-border.vue?vue&type=template&id=442c88a2&scoped=true"
import script from "./u-tabs-border.vue?vue&type=script&lang=js"
export * from "./u-tabs-border.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442c88a2",
  null
  
)

export default component.exports